module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "m-l-50 m-t-30 w-500"
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules,
      "label-width": "130px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "使用消息通道"
    }
  }, [_c('el-checkbox-group', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.FLOW_PIPELINES),
      expression: "form.FLOW_PIPELINES"
    }],
    domProps: {
      "value": (_vm.form.FLOW_PIPELINES)
    },
    on: {
      "input": function($event) {
        _vm.form.FLOW_PIPELINES = $event
      }
    }
  }, _vm._l((_vm.pipelines), function(option) {
    return _c('el-checkbox', {
      attrs: {
        "label": option.id
      }
    }, [_vm._v("\n          " + _vm._s(option.name) + "\n        ")])
  }))]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "可用模板变量标签"
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.templet
    }
  }, [_c('el-table-column', {
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "prop": "name",
      "label": "变量名"
    }
  }), _vm._v(" "), _c('el-table-column', {
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "prop": "tag",
      "label": "标签"
    }
  })])]), _vm._v(" "), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "审批/任务收到待办时提醒内容"
    }
  }, [_c('div', {
    staticClass: "m-b-10"
  }, [_c('span', [_vm._v("标题")]), _vm._v(" "), _c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.FLOW_MSG_RECEIVE_TITLE),
      expression: "form.FLOW_MSG_RECEIVE_TITLE"
    }],
    domProps: {
      "value": (_vm.form.FLOW_MSG_RECEIVE_TITLE)
    },
    on: {
      "input": function($event) {
        _vm.form.FLOW_MSG_RECEIVE_TITLE = $event
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "m-b-10"
  }, [_c('span', [_vm._v("内容")]), _vm._v(" "), _c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.FLOW_MSG_RECEIVE_CONTENT),
      expression: "form.FLOW_MSG_RECEIVE_CONTENT"
    }],
    attrs: {
      "type": "textarea",
      "rows": 4
    },
    domProps: {
      "value": (_vm.form.FLOW_MSG_RECEIVE_CONTENT)
    },
    on: {
      "input": function($event) {
        _vm.form.FLOW_MSG_RECEIVE_CONTENT = $event
      }
    }
  })])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "审批退回通知时提醒内容"
    }
  }, [_c('div', {
    staticClass: "m-b-10"
  }, [_c('span', [_vm._v("标题")]), _vm._v(" "), _c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.FLOW_MSG_BACK_TITLE),
      expression: "form.FLOW_MSG_BACK_TITLE"
    }],
    domProps: {
      "value": (_vm.form.FLOW_MSG_BACK_TITLE)
    },
    on: {
      "input": function($event) {
        _vm.form.FLOW_MSG_BACK_TITLE = $event
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "m-b-10"
  }, [_c('span', [_vm._v("内容")]), _vm._v(" "), _c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.FLOW_MSG_BACK_CONTENT),
      expression: "form.FLOW_MSG_BACK_CONTENT"
    }],
    attrs: {
      "type": "textarea",
      "rows": 4
    },
    domProps: {
      "value": (_vm.form.FLOW_MSG_BACK_CONTENT)
    },
    on: {
      "input": function($event) {
        _vm.form.FLOW_MSG_BACK_CONTENT = $event
      }
    }
  })])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "流程结束提醒申请人时提醒内容"
    }
  }, [_c('div', {
    staticClass: "m-b-10"
  }, [_c('span', [_vm._v("标题")]), _vm._v(" "), _c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.FLOW_MSG_END_TITLE),
      expression: "form.FLOW_MSG_END_TITLE"
    }],
    domProps: {
      "value": (_vm.form.FLOW_MSG_END_TITLE)
    },
    on: {
      "input": function($event) {
        _vm.form.FLOW_MSG_END_TITLE = $event
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "m-b-10"
  }, [_c('span', [_vm._v("内容")]), _vm._v(" "), _c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.FLOW_MSG_END_CONTENT),
      expression: "form.FLOW_MSG_END_CONTENT"
    }],
    attrs: {
      "type": "textarea",
      "rows": 4
    },
    domProps: {
      "value": (_vm.form.FLOW_MSG_END_CONTENT)
    },
    on: {
      "input": function($event) {
        _vm.form.FLOW_MSG_END_CONTENT = $event
      }
    }
  })])]), _vm._v(" "), _c('el-form-item', [_c('el-form-item', {
    attrs: {
      "label": "自动知会消息提醒内容"
    }
  }, [_c('div', {
    staticClass: "m-b-10"
  }, [_c('span', [_vm._v("标题")]), _vm._v(" "), _c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.FLOW_NOTIFY_TITLE),
      expression: "form.FLOW_NOTIFY_TITLE"
    }],
    domProps: {
      "value": (_vm.form.FLOW_NOTIFY_TITLE)
    },
    on: {
      "input": function($event) {
        _vm.form.FLOW_NOTIFY_TITLE = $event
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "m-b-10"
  }, [_c('span', [_vm._v("内容")]), _vm._v(" "), _c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.FLOW_NOTIFY_CONTENT),
      expression: "form.FLOW_NOTIFY_CONTENT"
    }],
    attrs: {
      "type": "textarea",
      "rows": 4
    },
    domProps: {
      "value": (_vm.form.FLOW_NOTIFY_CONTENT)
    },
    on: {
      "input": function($event) {
        _vm.form.FLOW_NOTIFY_CONTENT = $event
      }
    }
  })])]), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.isLoading
    },
    on: {
      "click": function($event) {
        _vm.add()
      }
    }
  }, [_vm._v("提交")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.goback()
      }
    }
  }, [_vm._v("返回")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6cccc030!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Flow/abstract/message.vue
// module id = 1905
// module chunks = 2